const getters = {
  userName: state => state.app.userName,
  locationInfo: state => state.map.locationInfo,
  mapOptions: state => state.map.mapOptions,
  poiInfo: state => state.map.poiInfo,
  routePath: state => state.map.routePath,
  naviState: state => state.map.naviState,
  naviStep: state => state.map.naviStep,
  userXdToken: state => state.app.userXdToken,
  exitLock: state => state.map.exitLock
};
export default getters;